<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input class="mt4" label="Tarikh Pendaftaran *" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <w-input class="mt4"  label="No. Tangki" type="text" v-model="form.no_tangki" :validators="[validators.required]"/>
            <z-select class="mt4" :items="model_tangki" label="Model Tangki *"  v-model="form.lkp_model_tangki_id"  :validators="[validators.required]"/>
            <w-input class="mt4"  label="No. Daftar Asset *" type="text" v-model="form.no_daftar_aset" :validators="[validators.required]"/>
            </div>
          <div class="mx2"></div>
          <div class="grow " >
            <w-input class="mt4" label="Kapasiti Tangki (L) *" type="text" v-model="form.kapasiti" :validators="[validators.required]"/>
            <w-input class="mt4" label="Bil. Canister *" type="text" v-model="form.bil_canister" :validators="[validators.required]"/>
            <w-input 
              class="mt4" 
              label="Tarikh Perolehan *" 
              type="date" 
              v-model="form.tarikh_perolehan" 
              :validators="[validators.required]" 
              :min="form.tarikh"
            />
            <z-money class="mt4" label="Nilai Perolehan (RM) *" v-model:originalValue="form.nilai_perolehan" :validators="[validators.required]"/>
          </div>
          </div>
        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3'])">
           <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
            </w-button>
          &nbsp;
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-form>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_model_tangki :[Array, Object],

    
  },
  data() {
    return {
      resourceurl: 'tangki.daftar',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Cecair Nitrogen', route: '/tangki' },
        { label: 'Daftar Tangki', route: '/tangki/daftar' },
      ],
      title : 'Daftar Tangki',
      form : this.d_form,
      model_tangki : this.d_model_tangki,

      
    }
  },
  methods: {
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('tangki.daftar.show', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('tangki.daftar.show',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('tangki.daftar.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('tangki.daftar.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('tangki.daftar.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      } 
      
    },

    

    getModel(){
          this.load = this.load + 1
        this.$zcomm.get(this.api_service + 'lookup/model_tangki', {}).then(res => {      
          this.model_tangki = res
        })
    },


  
   tutup(){
         this.$inertia.visit(window.route('tangki.daftar.index'));
       },
    



    
  },

  watch: {

  },
  mounted() {
  this.getModel()

  if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Daftar Tangki'
    }
    else
    {
      this.title = 'Tambah Daftar Tangki'
    }
   
    
  }
    
}
</script>
